var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c(
      "div",
      { staticClass: "documents" },
      [
        _c(
          "router-link",
          {
            staticClass: "mail-link",
            attrs: { to: "/user-agreement", target: "_blank" },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("title.userAgreement")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "mail-link",
            attrs: { to: "/privacy-policy", target: "_blank" },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("title.privacyPolicy")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer-text pl-3" }, [
      _vm._v("\n        " + _vm._s(_vm.$t("message.anyProblems"))),
      _c(
        "a",
        {
          staticClass: "mail-link pl-1",
          attrs: {
            href: "https://support.infomir.ru/open.php",
            target: "_blank",
          },
        },
        [_vm._v(_vm._s(_vm.$t("button.letterUs")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }